module.exports = __webpack_public_path__ + "static/img/dev1.4a53030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/dev1.jpg
// module id = KSBn
// module chunks = 3